/**
 * The shapes this page draws in, shared by the parts it was split into
 * (Task 3.2). Theme tokens only: no hex anywhere, so all three themes --
 * light, dark and high-contrast -- follow from the tokens rather than from
 * each component remembering to.
 */

export const thStyle      = { padding: '8px 12px', textAlign: 'start', fontWeight: 600 };
export const tdStyle      = { padding: '8px 12px' };
export const dimStyle     = { fontSize: 13, color: 'var(--c-text-faint-fg)' };
export const errStyle     = { color: 'red', fontSize: 13, margin: '0 0 10px' };
export const subFormStyle = { background: 'var(--c-bg-subtle)', border: '1px solid var(--c-border)', borderRadius: 8, padding: 14, marginBottom: 12 };
export const stepDescStyle = { fontSize: 13, color: 'var(--c-text-muted-fg)', margin: '0 0 18px' };

export const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
  gap: 12,
  marginBottom: 16,
};

export const labelStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  fontSize: 14,
  fontWeight: 500,
};

export const inputStyle = {
  padding: '6px 10px',
  border: '1px solid var(--c-border-strong)',
  borderRadius: 6,
  fontSize: 14,
  fontWeight: 400,
};

// Free-text habitat and locality fields have no dropdown to imply what belongs
// in them, so each carries an example underneath.
export const hintStyle = {
  fontSize: 12,
  fontWeight: 400,
  color: 'var(--c-text-muted-fg)',
};

export const btnStyle = (bg) => ({
  background: bg,
  color: 'var(--c-on-accent)',
  border: 'none',
  borderRadius: 6,
  padding: '8px 16px',
  cursor: bg === 'var(--c-text-faint)' ? 'not-allowed' : 'pointer',
  fontSize: 14,
});

export const wizardContainerStyle = {
  background: 'var(--c-bg-subtle)',
  border: '1px solid var(--c-border)',
  borderRadius: 8,
  padding: 24,
  marginBottom: 24,
};

export const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

export const modalStyle = {
  background: 'var(--c-surface)',
  borderRadius: 10,
  padding: 28,
  width: 700,
  maxWidth: '92vw',
  maxHeight: '88vh',
  overflowY: 'auto',
  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
};
